import { render, staticRenderFns } from "./expert-team.vue?vue&type=template&id=11634c06&scoped=true&"
import script from "./expert-team.vue?vue&type=script&lang=js&"
export * from "./expert-team.vue?vue&type=script&lang=js&"
import style0 from "./expert-team.vue?vue&type=style&index=0&id=11634c06&scoped=true&lang=scss&"
import style1 from "./expert-team.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11634c06",
  null
  
)

export default component.exports